import { render, staticRenderFns } from "./pos-contact-details-unpaid-column.vue?vue&type=template&id=4acd27a0&scoped=true&"
import script from "./pos-contact-details-unpaid-column.vue?vue&type=script&lang=ts&"
export * from "./pos-contact-details-unpaid-column.vue?vue&type=script&lang=ts&"
import style0 from "./pos-contact-details-unpaid-column.vue?vue&type=style&index=0&id=4acd27a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd27a0",
  null
  
)

export default component.exports